export function imageVariants2srcSetDensity(
  imageVariants: Array<{ density: string; cdnUrl: string }>
): string | null {
  if (imageVariants.length) {
    return imageVariants
      .map((imageVariant) => {
        return `${imageVariant.cdnUrl} ${imageVariant.density}x`
      })
      .join(', ')
  } else {
    return null
  }
}
